import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/index.scss'

import i18n from './i18n/i18n'
import VueLazyload from 'vue-lazyload';

i18n.locale = localStorage.getItem('lang') || 'en';
Vue.use(VueLazyload)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
